import { Api } from '@monorepo/shared/apiClient';
import {
  invalidateOrganizationDocumentsCache,
  OrganizationDocumentsCacheEvents,
} from '@monorepo/shared/cacheRegisters/documents/organizationDocumentsCacheRegister';
import { MutationConfig, useMutation } from 'react-query';

type UseDeleteOrganizationDocumentParams = {
  config?: MutationConfig<void, Api.ErrorResponse>;
};

export const useDeleteOrganizationDocument = (
  params?: UseDeleteOrganizationDocumentParams,
) =>
  useMutation(Api.deleteOrganizationDocument, {
    ...params?.config,
    onSuccess: (data, vars) => {
      invalidateOrganizationDocumentsCache(
        OrganizationDocumentsCacheEvents.DELETE,
        { organizationId: vars.organizationId },
      );
      return params?.config?.onSuccess?.(data, vars);
    },
  });
